module.exports = __webpack_public_path__ + "assets1779866876160/img/avator.bd584bb1.png";